import {
  LOGIN_SUCCESS,
  OTP_SENT,
  OTP_VERIFY,
  LOGIN_FAIL,
  USER_LOADING_ERROR,
  USER_LOADING_SUCCESS,
  USER_LOGOUT,
  SELECT_OTP_PLATFORM,
  REGISTER_ANOTHER_ACCOUNT,
  REGISTER_ANOTHER_ACCOUNT_FAIL,
  GET_ADMIN_UPDATED_DATA,
  GET_ADMIN_UPDATED_DATA_ERROR,
  LIST_OF_PLAN_HISTORY,
  LIST_OF_PLAN_HISTORY_ERROR,
} from "../ActionTypes";
const userData = sessionStorage.getItem("user");
const isAuthenticatedData = sessionStorage.getItem("isAuthenticated");
const isVerifiedData = sessionStorage.getItem("isVerified");

const initialState = {
  token: sessionStorage.getItem("token") || "",
  isAuthenticated: isAuthenticatedData
    ? JSON.parse(isAuthenticatedData)
    : false,
  loading: true,
  user: userData ? JSON.parse(userData) : null,
  isVerified: isVerifiedData ? JSON.parse(isVerifiedData) : false,
  selectedValue: sessionStorage.getItem("selectedValue") || "email",
  registerData: null,
  plans: null
};

const authStore = (state = initialState, action: any = {}) => {
  const { type, payload, otpType } = action;

  switch (type) {
    case LOGIN_SUCCESS: {
      sessionStorage.setItem("isAuthenticated", "false");
      sessionStorage.setItem("isVerified", "false");
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        isVerified: false,
        selectedValue: null,
      };
    }
    case SELECT_OTP_PLATFORM: {
      sessionStorage.setItem("selectedValue", payload);
      return {
        ...state,
        selectedValue: payload,
      };
    }
    case OTP_SENT: {
      sessionStorage.setItem("isAuthenticated", "true");
      sessionStorage.setItem("selectedValue", otpType);
      return {
        ...state,
        isAuthenticated: true,
        selectedValue: otpType,
      };
    }
    case OTP_VERIFY: {
      sessionStorage.setItem("isVerified", "true");
      sessionStorage.setItem("token", payload.access_token);
      sessionStorage.setItem("user", JSON.stringify(payload.data));
      return {
        ...state,
        token: payload.access_token,
        user: payload.data,
        isVerified: true,
      };
    }
    case USER_LOADING_SUCCESS: {
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        user: payload,
      };
    }
    case USER_LOADING_ERROR: {
      sessionStorage.clear();
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: {},
        selectedValue: null,
      };
    }
    case LOGIN_FAIL: {
      sessionStorage.clear();
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: {},
        selectedValue: null,
      };
    }
    case USER_LOGOUT: {
      sessionStorage.clear();
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        selectedValue: null,
      };
    }
    case GET_ADMIN_UPDATED_DATA: {
      return {
        ...state,
        userUpdated: payload,
      }
    }
    case GET_ADMIN_UPDATED_DATA_ERROR: {
      return {
        ...state,
        userUpdated: null,
      }
    }
    case REGISTER_ANOTHER_ACCOUNT: {
      return {
        ...state,
        registerData: payload,
      };
    }
    case REGISTER_ANOTHER_ACCOUNT_FAIL: {
      return {
        ...state,
        registerData: null,
      };
    }
    case LIST_OF_PLAN_HISTORY: {
      return {
        ...state,
        plans: payload,
      };
    }
    case LIST_OF_PLAN_HISTORY_ERROR: {
      return {
        ...state,
        plans: null,
      };
    }
    default:
      return state;
  }
};

export default authStore;
